import * as Yup from 'yup'

export const NewsletterSignupValidationSchema = Yup.object().shape({
  email: Yup.string().required().email(),
  firstname: Yup.string().required(),
  lastname: Yup.string().required(),
})